import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import DashboardHeader from "./DashboardHeader";
import APIs from "../../APIs";

const Quotation = () => {
  const [quotations, setQuotations] = useState([]);
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const user_id = userData?.user_id;
  const location = useLocation();

  useEffect(() => {
    const fetchQuotations = async () => {
      try {
        if (!user_id) return;

        const res = await APIs.post(
          "quote/getQuotesByUserId",
          { user_id },
          { headers: { "Content-Type": "application/json" } }
        );

        console.log("📌 Quotes API response:", res.data);

        const quotes = res.data?.data || [];
        setQuotations(quotes);
      } catch (err) {
        console.error("❌ Error fetching quotations:", err);
        setQuotations([]);
      }
    };

    fetchQuotations();
  }, [user_id]);

  // Helper to format dates in "May 31, 2025" format
  const formatQuotationDate = (dateStr) => {
    if (!dateStr) return "N/A";

    const date = new Date(dateStr); // e.g., "2025-09-24 11:53:36"
    if (isNaN(date)) return "N/A";

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Helper to format pickup/drop addresses
  const formatAddress = (quote, type) => {
    const fields = [
      quote[`${type}_address`],
      quote[`${type}_landmark`],
      quote[`${type}_city`],
      quote[`${type}_state`],
      quote[`${type}_country`],
      quote[`${type}_zip_code`],
    ].filter(Boolean); // remove empty strings
    return fields.join(", ");
  };

  return (
    <div className="page-content">
      <section className="step-section-md">
        <div className="container">
          <div className="row">
            {/* Sidebar only if not dashboard */}
            {location.pathname !== "/dashboard" && (
              <div className="col-lg-3">
                <Sidebar />
              </div>
            )}

            <div className="col-lg-9">
              {/* <DashboardHeader /> */}
              {/* Save Quotations */}
              <div className="card mt-30">
                <div className="card-header bg-white">
                  <h5 className="card-title">Save Quotations</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12">
                      {quotations.length > 0 ? (
                        quotations.map((quote, idx) => {
                          const pickup_address = formatAddress(quote, "pickup");
                          const drop_address = formatAddress(quote, "drop");

                          return (
                            <div className="orders-container mb-4" key={idx}>
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="selected-service">
                                    <div className="service-detail d-flex align-items-center">
                                      <div className="service-icon me-3">
                                        <img
                                          src={
                                            quote.category_image ||
                                            "/images/homepage-2/ihbox/icon-img-01.png"
                                          }
                                          alt={quote.category_name || "Important Documents"}
                                        />
                                      </div>
                                      <div>
                                        <div className="service-title">
                                          <h5>{quote.category_name || "Important Documents"}</h5>
                                        </div>
                                        <div className="Order-id">
                                          <p className="mb-0">
                                            Quotation Id: <span>{quote.quote_no}</span>
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="order-price-status status_style mt-2">
                                      <div className={`status ${
                                        quote.quote_status === "Requested" ? "bg-blue" : "bg-success"
                                      }`}>
                                        {quote.quote_status === "Requested"
                                          ? "Waiting for Admin Approval"
                                          : quote.quote_status || "N/A"}
                                      </div>
                                      <p className="mb-0">
                                        Quotation Date: <span>{formatQuotationDate(quote.quotation_date)}</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <div className="location-container">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="pickup_location">
                                          <div className="locationdetails">
                                            <h5>Pickup Location</h5>
                                            <p>{pickup_address}</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="drop_location">
                                          <div className="locationdetails">
                                            <h5>Drop Location</h5>
                                            <p>{drop_address}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                 <div className="d-flex justify-content-end gap-3">
                                  {quote.quote_status === "Submitted" ? (
                                    <p className="text-style mb-0">
                                      The quotation has been revised and submitted by the admin. Please review the details,
                                      approve the quotation, and proceed with payment to confirm your shipment booking.
                                    </p>
                                  ) : (
                                    <p className="mb-0">{""}</p>
                                  )}

                                  <Link
                                    to={`/quotationdetails/${quote.quote_id}`}
                                    className="btn btn-outline-dark text-nowrap btn-fit"
                                   
                                  >
                                    View Details
                                  </Link>
                                </div>

                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="col-12 text-center my-5">
                          <img
                            src="/images/nodatafoundimg.png"
                            alt="No quotations found"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "200px" }}
                          />
                          <p>No Quotations found.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* End Save Quotations */}
            </div>


          </div>
        </div>
      </section>
    </div>
  );
};

export default Quotation;
